<div class="body">

    <mat-toolbar class="ams-toolbar">

        <mat-icon class="main-icon">security</mat-icon>

        <span>
            Passwort ändern
        </span>

        <span class="spacer"></span>

        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>

    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <app-change-password-form></app-change-password-form>

        <div class="error-hint" *ngIf="error">
            Das hat nicht geklappt
        </div>

    </div>

    <div class="footer">

        <button mat-raised-button (click)="close()">
            Abbrechen
        </button>

        <button mat-raised-button color="primary" (click)="confirm()">
            Passwort ändern
        </button>

    </div>

</div>
